import { render, staticRenderFns } from "./Airports.vue?vue&type=template&id=fc09f72e&"
import script from "./Airports.vue?vue&type=script&lang=js&"
export * from "./Airports.vue?vue&type=script&lang=js&"
import style0 from "./Airports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports